<template>
  <div
    class="ui-top-nav-item nav-item"
    :class="[`nav-item--${variant}`, { active }]"
    role="button"
    tabindex="0"
    @click="$emit('click', $event)"
    @keydown.enter.prevent="$emit('click', $event)"
    @keydown.space.prevent="$emit('click', $event)"
  >
    <span class="nav-item__icon" aria-hidden="true">
      <i :class="icon"></i>
    </span>
    <span class="nav-item__label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'TopNavItem',
  props: {
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      default: 'home',
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
};
</script>

<style src="../styles/TopNavItem.css"></style>
